import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFabera = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.1058 0H2.2942C2.11262 0 1.94531 0.0984458 1.85712 0.257178L0.134901 3.35718C0.0510057 3.50819 0.0510055 3.69181 0.134901 3.84282L1.85712 6.94282C1.94531 7.10155 2.11262 7.2 2.2942 7.2H6.1058C6.28738 7.2 6.45469 7.10155 6.54288 6.94282L8.2651 3.84282C8.34899 3.69181 8.34899 3.50819 8.2651 3.35718L6.54288 0.257179C6.45469 0.098446 6.28738 0 6.1058 0Z",
			fill: "#166BD8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.1058 8.8H2.2942C2.11262 8.8 1.94531 8.89845 1.85712 9.05718L0.134901 12.1572C0.0510057 12.3082 0.0510055 12.4918 0.134901 12.6428L1.85712 15.7428C1.94531 15.9016 2.11262 16 2.2942 16H6.1058C6.28738 16 6.45469 15.9016 6.54288 15.7428L8.2651 12.6428C8.34899 12.4918 8.34899 12.3082 8.2651 12.1572L6.54288 9.05718C6.45469 8.89845 6.28738 8.8 6.1058 8.8Z",
			fill: "#D7251C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7058 4.39999H9.8942C9.71262 4.39999 9.54531 4.49844 9.45712 4.65717L7.7349 7.75717C7.651 7.90818 7.651 8.0918 7.7349 8.24282L9.45712 11.3428C9.54531 11.5015 9.71262 11.6 9.8942 11.6H13.7058C13.8874 11.6 14.0547 11.5015 14.1429 11.3428L15.8651 8.24282C15.949 8.0918 15.949 7.90818 15.8651 7.75717L14.1429 4.65717C14.0547 4.49844 13.8874 4.39999 13.7058 4.39999Z",
			fill: "#1B2328"
		})
	]
});
export default SvgFabera;
